/**
 * Clears the table data filters.
 */
export function clearFilters() {
	const $container = $( '.m__dashboard-header' );
	const $tableContainer = $( '.m__dashboard-table' );
	const $clearButton = $container.find( '.m__dashboard-filters-clear' );
	const $textInput = $container.find( '.input-filter-text' );
	const $filterInput = $container.find( '.filter-item-main' );

	$clearButton.on( 'click', () => {
		$textInput.val( '' );
		$filterInput.html( 'Select' );
		$tableContainer.trigger( 'tableUpdate' );
		$clearButton.hide();
	});

	$container.on( 'filtersActive', function showClearFilterButton() {
		$clearButton.css( 'display', 'inline-flex' );
	});
}